"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedOverrides = void 0;
/* ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️
 * Changing shared code can have unintended consequences for all brands.
 * Please double check with the team before making changes here.
 * If brand specific changes are needed, they should be made in the brand's theme file.
 */
var material_1 = require("@mui/material");
var resolveTypographyVariantStyles_1 = require("../utils/resolveTypographyVariantStyles");
var resolveBrandBodyFont_1 = require("../utils/resolveBrandBodyFont");
var sharedOverrides = function (brand) { return ({
    MuiScopedCssBaseline: {
        styleOverrides: {
            root: {
                height: '100%',
                background: 'none',
                fontSize: 16,
                fontFamily: (0, resolveBrandBodyFont_1.resolveBrandBodyFont)(brand),
                overflowX: 'hidden',
            },
        },
    },
    MuiFormLabel: {
        styleOverrides: {
            root: function (_a) {
                var theme = _a.theme;
                return (__assign(__assign({}, (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'bodyMediumSemiBold')), { '&.Mui-error': {
                        color: "var(--error-700, ".concat(theme.palette.error.dark, ")"),
                    }, '&.Mui-disabled.Mui-disabled': {
                        color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
                    } }));
            },
        },
    },
    MuiFormControlLabel: {
        styleOverrides: {
            root: function (_a) {
                var theme = _a.theme;
                return (__assign(__assign({}, (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'bodyMediumBook')), { '&.Mui-error': {
                        color: "var(--error-700, ".concat(theme.palette.error.dark, ")"),
                    }, '&.Mui-disabled.Mui-disabled': {
                        color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
                    } }));
            },
        },
    },
    MuiFormHelperText: {
        styleOverrides: {
            root: function (_a) {
                var theme = _a.theme;
                return (__assign(__assign({}, (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'assistiveText')), { '&.Mui-error': __assign({}, (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'errorValidation')) }));
            },
        },
    },
    MuiStepLabel: {
        styleOverrides: {
            root: function (_a) {
                var _b;
                var theme = _a.theme;
                return (_b = {},
                    _b[".".concat(material_1.stepLabelClasses.iconContainer)] = {
                        paddingTop: '0.4rem',
                    },
                    _b[".".concat(material_1.stepLabelClasses.labelContainer, " > .").concat(material_1.stepLabelClasses.label)] = __assign(__assign({}, (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'bodySmallBookStyles')), { color: "var(--text-tertiary, ".concat(theme.palette.text.tertiary, ")"), marginTop: '0.5rem' }),
                    _b[".".concat(material_1.stepLabelClasses.labelContainer, " > .").concat(material_1.stepLabelClasses.active)] = __assign(__assign({}, (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'bodySmallBookStyles')), { color: "var(--secondary-700, ".concat(theme.palette.secondary.dark, ")") }),
                    _b[".".concat(material_1.stepLabelClasses.labelContainer, " > .").concat(material_1.stepLabelClasses.label, ".").concat(material_1.stepLabelClasses.completed)] = __assign(__assign({}, (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'bodySmallBookStyles')), { color: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")") }),
                    _b);
            },
        },
    },
    MuiStepConnector: {
        styleOverrides: {
            root: function (_a) {
                var _b, _c, _d, _e;
                var theme = _a.theme;
                return (_b = {},
                    _b["&.".concat(material_1.stepConnectorClasses.active)] = (_c = {},
                        _c["& .".concat(material_1.stepConnectorClasses.line)] = {
                            borderColor: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
                        },
                        _c),
                    _b["&.".concat(material_1.stepConnectorClasses.completed)] = (_d = {},
                        _d["& .".concat(material_1.stepConnectorClasses.line)] = {
                            borderColor: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
                        },
                        _d),
                    _b["&.".concat(material_1.stepConnectorClasses.disabled)] = (_e = {},
                        _e["& .".concat(material_1.stepConnectorClasses.line)] = {
                            borderColor: "var(--neutrals-300, ".concat(theme.palette.neutrals.primary, ")"),
                        },
                        _e),
                    _b);
            },
        },
    },
    MuiTextField: {
        styleOverrides: {
            root: function (_a) {
                var _b, _c, _d, _e;
                var theme = _a.theme;
                var baseInputStyles = (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'bodyMediumBook');
                var inputStyles = (_b = {},
                    _b["& .".concat(material_1.inputBaseClasses.input)] = __assign({}, baseInputStyles),
                    _b);
                var floatingLabelBase = (_c = {},
                    _c["& .".concat(material_1.formLabelClasses.root, ".").concat(material_1.inputLabelClasses.shrink, ":not(.Mui-error)")] = __assign(__assign({}, (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'floatingLabel')), { 
                        // floatingLabel font styles don't work with the MuiTextField, so we need to override them
                        fontSize: '1rem', lineHeight: '1.5rem', color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }),
                    _c["& .".concat(material_1.formLabelClasses.root, ".").concat(material_1.inputLabelClasses.shrink, ".").concat(material_1.inputLabelClasses.focused, ":not(.Mui-error)")] = {
                        color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
                    },
                    _c);
                var defaultLabelStyles = (_d = {},
                    _d["& .".concat(material_1.formLabelClasses.root)] = __assign(__assign({}, baseInputStyles), { color: "var(--text-primary, ".concat(theme.palette.text.primary, ")") }),
                    _d);
                var disabledInputStyles = (_e = {},
                    _e["& input:disabled .".concat(material_1.formLabelClasses.root)] = {
                        color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
                    },
                    _e);
                return __assign(__assign(__assign(__assign({ width: '100%' }, inputStyles), floatingLabelBase), defaultLabelStyles), disabledInputStyles);
            },
        },
    },
    MuiSelect: {
        styleOverrides: {
            select: function (_a) {
                var theme = _a.theme;
                return (__assign({ width: '100%' }, (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'bodyMediumBook')));
            },
        },
    },
    MuiBreadcrumbs: {
        styleOverrides: {
            root: function (_a) {
                var _b;
                var theme = _a.theme;
                return _b = {},
                    _b["& .".concat(material_1.breadcrumbsClasses.li)] = __assign({}, (0, resolveTypographyVariantStyles_1.resolveTypographyVariantStyles)(theme, 'breadcrumbLarge')),
                    _b;
            },
        },
        defaultProps: {
            separator: '›',
        },
    },
    MuiIconButton: {
        styleOverrides: {
            root: function (_a) {
                var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                var theme = _a.theme, ownerState = _a.ownerState;
                var hoverAndActiveStyleDefault = {
                    '&:hover': {
                        color: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
                    },
                    '&:active': {
                        color: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"),
                    },
                };
                var svgIconColorHighContrast = ownerState.disabled
                    ? "var(--neutrals-700, ".concat(theme.palette.neutrals.disabled, ")")
                    : theme.palette.background.default;
                var svgIconColorDestructive = ownerState.disabled
                    ? "var(--neutrals-700, ".concat(theme.palette.neutrals.disabled, ")")
                    : theme.palette.error.dark;
                switch (ownerState.size) {
                    case 'extraSmall': {
                        if (ownerState.color === 'highContrast') {
                            return _b = {},
                                _b["> .".concat(material_1.svgIconClasses.root)] = {
                                    color: svgIconColorHighContrast,
                                    fontSize: '1.25rem',
                                },
                                _b['&:hover'] = {
                                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.2),
                                },
                                _b;
                        }
                        if (ownerState.color === 'destructive') {
                            return _c = {},
                                _c["> .".concat(material_1.svgIconClasses.root)] = {
                                    color: svgIconColorDestructive,
                                    fontSize: '1.25rem',
                                },
                                _c['&:hover'] = {
                                    backgroundColor: theme.palette.error.light,
                                },
                                _c;
                        }
                        return _d = {},
                            _d["> .".concat(material_1.svgIconClasses.root)] = __assign({ fontSize: '1.25rem' }, hoverAndActiveStyleDefault),
                            _d;
                    }
                    case 'small': {
                        if (ownerState.color === 'highContrast') {
                            return _e = {},
                                _e["> .".concat(material_1.svgIconClasses.root)] = {
                                    color: svgIconColorHighContrast,
                                    fontSize: '1.5rem',
                                },
                                _e['&:hover'] = {
                                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.2),
                                },
                                _e;
                        }
                        if (ownerState.color === 'destructive') {
                            return _f = {},
                                _f["> .".concat(material_1.svgIconClasses.root)] = {
                                    color: svgIconColorDestructive,
                                    fontSize: '1.25rem',
                                },
                                _f['&:hover'] = {
                                    backgroundColor: theme.palette.error.light,
                                },
                                _f;
                        }
                        return _g = {},
                            _g["> .".concat(material_1.svgIconClasses.root)] = __assign({ fontSize: '1.5rem' }, hoverAndActiveStyleDefault),
                            _g;
                    }
                    case 'medium': {
                        if (ownerState.color === 'highContrast') {
                            return _h = {},
                                _h["> .".concat(material_1.svgIconClasses.root)] = {
                                    color: svgIconColorHighContrast,
                                    fontSize: '1.75rem',
                                },
                                _h['&:hover'] = {
                                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.2),
                                },
                                _h;
                        }
                        if (ownerState.color === 'destructive') {
                            return _j = {},
                                _j["> .".concat(material_1.svgIconClasses.root)] = {
                                    color: svgIconColorDestructive,
                                    fontSize: '1.25rem',
                                },
                                _j['&:hover'] = {
                                    backgroundColor: theme.palette.error.light,
                                },
                                _j;
                        }
                        return _k = {},
                            _k[">.".concat(material_1.svgIconClasses.root)] = __assign({ fontSize: '1.75rem' }, hoverAndActiveStyleDefault),
                            _k;
                    }
                    case 'large': {
                        if (ownerState.color === 'highContrast') {
                            return _l = {},
                                _l["> .".concat(material_1.svgIconClasses.root)] = {
                                    color: svgIconColorHighContrast,
                                    fontSize: '2rem',
                                },
                                _l['&:hover'] = {
                                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.2),
                                },
                                _l;
                        }
                        if (ownerState.color === 'destructive') {
                            return _m = {},
                                _m["> .".concat(material_1.svgIconClasses.root)] = {
                                    color: svgIconColorDestructive,
                                    fontSize: '1.25rem',
                                },
                                _m['&:hover'] = {
                                    backgroundColor: theme.palette.error.light,
                                },
                                _m;
                        }
                        return _o = {},
                            _o["> .".concat(material_1.svgIconClasses.root)] = __assign({ fontSize: '2rem' }, hoverAndActiveStyleDefault),
                            _o;
                    }
                    default: {
                        return {
                            '&:active': {
                                backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.6),
                            },
                            '&:hover': {
                                backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.disabled, 0.2),
                            },
                        };
                    }
                }
            },
        },
    },
}); };
exports.sharedOverrides = sharedOverrides;
